function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGeneralVisitReportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 503.322 503.322",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#546080"
    },
    d: "M295.051,34.712V17.356C295.051,7.81,287.241,0,277.695,0h-52.068 c-9.546,0-17.356,7.81-17.356,17.356v17.356h-34.712c-5.207,0-8.678,3.471-8.678,8.678v60.746c0,5.207,4.339,8.678,8.678,8.678 h156.203c5.207,0,8.678-4.339,8.678-8.678V43.39c0-5.207-3.471-8.678-8.678-8.678H295.051z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#875F38"
    },
    d: "M338.441,60.746v43.39c0,5.207-4.339,8.678-8.678,8.678H173.559c-5.207,0-8.678-4.339-8.678-8.678 v-43.39h-86.78v442.576H425.22V60.746H338.441z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D4D0BA"
    },
    points: "312.407,459.932 312.407,390.508 381.831,390.508 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0EDE0"
    },
    d: "M338.441,95.458v8.678c0,5.207-4.339,8.678-8.678,8.678H173.559c-5.207,0-8.678-4.339-8.678-8.678 v-8.678h-43.39v364.475h190.915v-69.424h69.424V95.458H338.441z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D4D0BA"
    },
    d: "M173.559,199.593h34.712v-34.712h-34.712V199.593z M216.949,216.949h-52.068 c-5.207,0-8.678-3.471-8.678-8.678v-52.068c0-5.207,3.471-8.678,8.678-8.678h52.068c5.207,0,8.678,3.471,8.678,8.678v52.068 C225.627,213.478,222.156,216.949,216.949,216.949L216.949,216.949z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D4D0BA"
    },
    d: "M173.559,295.051h34.712v-34.712h-34.712V295.051z M216.949,312.407h-52.068 c-5.207,0-8.678-3.471-8.678-8.678v-52.068c0-5.207,3.471-8.678,8.678-8.678h52.068c5.207,0,8.678,3.471,8.678,8.678v52.068 C225.627,308.936,222.156,312.407,216.949,312.407L216.949,312.407z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D4D0BA"
    },
    d: "M173.559,390.508h34.712v-34.712h-34.712V390.508z M216.949,407.864h-52.068 c-5.207,0-8.678-3.471-8.678-8.678v-52.068c0-5.207,3.471-8.678,8.678-8.678h52.068c5.207,0,8.678,3.471,8.678,8.678v52.068 C225.627,404.393,222.156,407.864,216.949,407.864L216.949,407.864z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D4D0BA"
    },
    d: "M338.441,164.881h-78.102c-5.207,0-8.678-3.471-8.678-8.678c0-5.207,3.471-8.678,8.678-8.678h78.102 c5.207,0,8.678,3.471,8.678,8.678C347.119,161.41,343.647,164.881,338.441,164.881"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D4D0BA"
    },
    d: "M312.407,208.271h-52.068c-5.207,0-8.678-3.471-8.678-8.678c0-5.207,3.471-8.678,8.678-8.678h52.068 c5.207,0,8.678,3.471,8.678,8.678C321.085,204.8,317.614,208.271,312.407,208.271"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D4D0BA"
    },
    d: "M338.441,260.339h-78.102c-5.207,0-8.678-3.471-8.678-8.678c0-5.207,3.471-8.678,8.678-8.678h78.102 c5.207,0,8.678,3.471,8.678,8.678C347.119,256.868,343.647,260.339,338.441,260.339"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D4D0BA"
    },
    d: "M312.407,303.729h-52.068c-5.207,0-8.678-3.471-8.678-8.678c0-5.207,3.471-8.678,8.678-8.678h52.068 c5.207,0,8.678,3.471,8.678,8.678C321.085,300.258,317.614,303.729,312.407,303.729"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D4D0BA"
    },
    d: "M338.441,364.475h-78.102c-5.207,0-8.678-3.471-8.678-8.678c0-5.207,3.471-8.678,8.678-8.678h78.102 c5.207,0,8.678,3.471,8.678,8.678C347.119,361.003,343.647,364.475,338.441,364.475"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D4D0BA"
    },
    d: "M277.695,407.864h-17.356c-5.207,0-8.678-3.471-8.678-8.678c0-5.207,3.471-8.678,8.678-8.678h17.356 c5.207,0,8.678,3.471,8.678,8.678C286.373,404.393,282.902,407.864,277.695,407.864"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralVisitReportIcon);
export default __webpack_public_path__ + "static/media/general_visit_report_icon.06fde8b1826b934e7dd0b22c93b1fa13.svg";
export { ForwardRef as ReactComponent };